import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-r from-primary to-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">B</span>
              </div>
              <div>
                <h3 className="text-xl font-bold">BUMDES Makmur</h3>
                <p className="text-gray-400 text-sm">Badan Usaha Milik Desa</p>
              </div>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              Platform digital untuk mengelola usaha desa secara transparan dan efisien. 
              Membangun ekonomi desa yang mandiri dan berkelanjutan.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <span className="sr-only">Facebook</span>
                📘
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <span className="sr-only">Instagram</span>
                📷
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <span className="sr-only">WhatsApp</span>
                💬
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Tautan Cepat</h4>
            <ul className="space-y-2">
              <li><a href="#beranda" className="text-gray-400 hover:text-white transition-colors">Beranda</a></li>
              <li><a href="#produk" className="text-gray-400 hover:text-white transition-colors">Produk</a></li>
              <li><a href="#keuangan" className="text-gray-400 hover:text-white transition-colors">Keuangan</a></li>
              <li><a href="#informasi" className="text-gray-400 hover:text-white transition-colors">Informasi</a></li>
              <li><a href="#tentang" className="text-gray-400 hover:text-white transition-colors">Tentang</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Kontak</h4>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-center">
                <span className="mr-2">📍</span>
                Desa Makmur, Kec. Sejahtera
              </li>
              <li className="flex items-center">
                <span className="mr-2">📞</span>
                (021) 1234-5678
              </li>
              <li className="flex items-center">
                <span className="mr-2">✉️</span>
                info@bumdesmakmur.id
              </li>
              <li className="flex items-center">
                <span className="mr-2">🕒</span>
                Senin - Jumat, 08:00 - 16:00
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 BUMDES Desa Makmur. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">Privacy Policy</a>
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;